import React from "react";

/**
 * Copyright (c) 2024. All rights reserved.
 */

const CommonFooter = () => (
  <footer className="common-footer">© 2025.All rights reserved.</footer>
);

export default CommonFooter;
